module.exports = __webpack_public_path__ + "static/portfolio-mas-14-cf09e546dd459d01fbc8f99da11fc1cf.jpg";